module.exports = __webpack_public_path__ + "img/to_shop_jp.03614b73.png";